export enum InvoiceTemplateFields {
    ITEMS = 'items',
    TITLE = 'title',
    IMG = 'img',
    PRODUCT_TYPE = 'productType',
    FOR_SUBJECTS = 'forSubjects',
    IS_FOR_ALL_SUBJECTS = 'isForAllSubjects',
    IS_HIDDEN = 'isHidden',
}
